@if (config) {
  <section class="info__panel">
    @if (config.header) {
      <div class="ip__header">
        <h6>{{ config.header }}</h6>
      </div>
    }
    <!--  Panel Content -->
    @for (item of config.items; track item) {
      <div class="ip__item">
        @if (item.headerLabel) {
          <div
            class="ip__item__header"
            role="link"
            description="item.headerLabel"
            (click)="item.headerIsClickable && headerIconClicked(item)"
          >
            <div class="ip__item__label">
              @if (item.headerIcon) {
                <icon class="ip__header__icon" [name]="item.headerIcon"> </icon>
              }
              <h4 class="t-data t-bold" [innerHTML]="item.headerLabel"></h4>
            </div>
            @if (item.headerIsClickable) {
              <icon
                [dataNavEvent]="item | getEventRoute: null"
                [name]="
                  item.headerClickableIcon
                    ? item.headerClickableIcon
                    : 'chevron_right'
                "
                [config]="
                  item.headerClickableIconConfig || {
                    fill: 'nav-link-icon-color',
                  }
                "
              >
              </icon>
            }
          </div>
        }
        @for (field of item.fields; track field) {
          @if (field.type === types.TEXT) {
            <div class="ip__item__content">
              <p
                class="t-data"
                [innerHTML]="field.label"
                [ngClass]="{ 't-bold': field.isFontBold }"
              ></p>
              @if (field.icon) {
                <icon
                  [name]="field.icon"
                  (click)="fieldIconClicked(field)"
                  [dataNavEvent]="item | getEventRoute: null"
                >
                </icon>
              }
            </div>
          }
          @if (field.type === types.LINK) {
            <div class="ip__item__content">
              <a
                class="t-data t-bold t-link"
                [attr.href]="field.route"
                target="_blank"
                [dataNavEvent]="item | getEventRoute: field"
              >
                {{ field.label }}
              </a>
            </div>
          }
          @if (field.type === types.PHONE) {
            <div class="ip__item__content">
              <p class="t-data">
                {{ field.label }}
                <a
                  class="t-data t-link t-bold"
                  [attr.href]="'tel:' + field.phone"
                  [dataNavEvent]="field | getPhoneEvent"
                >
                  {{ field.phone }}
                </a>
              </p>
            </div>
          }
        }
      </div>
    }
  </section>
}
